import { render, staticRenderFns } from "./TickIcon.vue?vue&type=template&id=301ef3e3&"
import script from "./TickIcon.vue?vue&type=script&lang=js&"
export * from "./TickIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports